<template>
  <div class="jump-useraddress nav-bar-fixed">
    <van-nav-bar title="创建出库单" left-arrow fixed @click-left="back" />
    <div class="jump-cart-body">
      <div class="jump-cart-body-hd"></div>

      <van-collapse v-model="activeNames">
        <van-collapse-item title="订单商品" name="2">
          <van-row class="jump-cart-item" type="flex" v-for="(item,index) in orderGoods">
            <van-col span="24">
              <p>
                <span style="font-size: 16px">商品名称：</span>
                {{item.goods_name}}
              </p>
               <p v-if="item.spec&&item.spec!=''">
                <span style="font-size: 16px">规格：</span>
                {{item.spec}}
              </p>
              <p>
                <span style="font-size: 16px">订货数量：</span>
                {{item.count}}
              </p>
              <p>
                <span style="font-size: 16px">单价：</span>
                {{item.price * item.discount}}
              </p>
              <p>
                <span style="font-size: 16px">小计：</span>
                {{item.minSum}}
              </p>
              <p>
                <span style="font-size: 16px">销售单位：</span>
                {{item.goods_unit_seller}}
              </p>
              <p>
                <span style="font-size: 16px">赠送数量：</span>
                {{item.give_count}}
              </p>
              <p>
                <span style="font-size: 16px">未出库数量：</span>
                {{item.none_delivery_goods_count}}
              </p>
              <p>
                <span style="font-size: 16px">促销活动：</span>
                {{item.pname}}
              </p>
            </van-col>
          </van-row>
        </van-collapse-item>

        <van-row v-if="workFlow.workflowType==10 && userRole.indexOf('TM')!=-1 && data.isTmDealOne">
          <van-collapse v-model="activeName" v-for="(item,index) in lists">
            <van-collapse-item :title="title[index]" :name="index">
              <van-row class="jump-messg-item" v-for="obj in goodInfo[index]">
                <van-col span="24">
                  <van-cell title="商品名称" :value="obj.goodName" />
                  <van-cell title="计划发货数量" :value="obj.num" />
                </van-col>
              </van-row>

              <van-row class="jump-messg-item">
                <van-col span="24">
                  <van-cell title="车次安排" :value="item.trainType==1?'专车':'拼车'" />
                  <van-cell title="车牌号" :value="item.plateNo" />
                  <van-cell title="司机手机号" :value="item.mobileDriver" />
                  <van-cell title="发车时间" :value="item.departureTime" />
                  <van-cell title="司机姓名" :value="item.driverName" />
                  <van-cell title="司机身份证号" :value="item.driverIdnumber" />
                </van-col>
              </van-row>
            </van-collapse-item>
          </van-collapse>
        </van-row>

        <van-collapse-item title="出库单明细信息" name="1">
          <van-row class="jump-cart-item" type="flex" v-for="(item,index) in orderGoods">
            <van-col span="24">
              <van-cell-group>
                <p>
                  <span style="color: black;margin-left: 15px">商品名称：</span>
                  {{item.goods_name}}
                </p>
                 <p v-if="item.spec&&item.spec!=''" style="margin-top:6px">
                  <span style="color: black;margin-left: 15px">规格：</span>
                  {{item.spec}}
                </p>

                <van-field
                  v-model="goodcode[index]"
                  readonly
                  label="出库编码"
                  placeholder="请选择出库编码"
                  @focus="goodcodeShow(item,index)"
                />

                <van-field v-model="goodprice[index]" label="出库单价" placeholder="请输入出库单价" />

                <van-field readonly v-model="item.jmbjg" label="价目表价格" placeholder />

                <van-field
                  readonly
                  v-model="item.none_delivery_goods_count"
                  label="未出库数量"
                  placeholder
                />

                <van-field v-model="goodchu[index]" label="本次出库数量" placeholder="请输入本次出库数量" />

                <van-field
                  v-model="supplier[index]"
                  readonly
                  label="供应商"
                  v-if="workFlow.workflowType==10"
                />
                <van-field
                  v-model="supplier[index]"
                  readonly
                  label="供应商"
                  placeholder="请选择供应商"
                  @focus="supplierShow(item,index)"
                  v-else
                />
                <van-row v-if="order.orderGoodsType==1 && item.erporjxc==null">
                  <van-field
                    v-model="syncInfo[index]"
                    readonly
                    label="同步"
                    placeholder="请选择"
                    @focus="syncShow(index)"
                  />
                </van-row>
                <van-row v-if="order.orderGoodsType==1 && item.erporjxc!=null">
                  <p>
                    <span style="color: black;margin-left: 15px">同步：</span>
                    {{syncInfo[index]}}
                  </p>
                </van-row>
                <van-row
                  v-if="workFlow.workflowType==10 && userRole.indexOf('TM')!=-1 && data.isTmDealOne"
                >
                  <van-field
                    v-model="contractList[index]"
                    readonly
                    label="执行合同"
                    placeholder="请选择执行合同"
                    @focus="contractShow(item,index)"
                  />
                </van-row>
              </van-cell-group>
            </van-col>
          </van-row>

          <!-- 出库编码 -->
          <van-popup v-model="goodcodeshow" position="bottom" :overlay="true">
            <van-picker
              :columns="goodcodecolumns"
              show-toolbar
              @cancel="goodcodeCancel"
              @confirm="goodcodeConfirm"
              @change="goodcodeChange"
            />
          </van-popup>

          <!-- 执行合同 -->
          <van-popup v-model="contracthow" position="bottom" :overlay="true">
          <van-search v-model="Contractvalue" placeholder="请输入关键字查询合同"  show-action @search="onSearch" @clear="onSearch">
               <template #action>
                  <div @click="onSearch">查询</div>
                </template>
          </van-search>
            <van-picker
              :columns="columns"
              show-toolbar
              value-key="name"
              @cancel="gcontractCancel"
              @confirm="contractConfirm"
              @change="contractChange"
            />
          </van-popup>

          <!-- 供应商 -->
          <van-popup v-model="suppliershow" position="bottom" :overlay="true">
            <van-picker
              :columns="suppliercolumns"
              show-toolbar
              value-key="name"
              @cancel="supplierCancel"
              @confirm="supplierConfirm"
              @change="supplierChange"
            />
          </van-popup>

          <!-- 同步 -->
          <van-popup v-model="syncshow" position="bottom" :overlay="true">
            <van-picker
              :columns="synccolumns"
              show-toolbar
              value-key="name"
              @cancel="syncCancel"
              @confirm="syncConfirm"
              @change="syncChange"
            />
          </van-popup>
        </van-collapse-item>
      </van-collapse>

      <van-radio-group v-model="radio">
        <van-cell-group v-for="dd in milkdeductamount.milkShopList">
          <van-cell v-bind:title="dd.orgName" clickable @click="radio = dd.orgCode">
            <van-radio :name="dd.orgCode" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
 <!-- 成品上传附件 -->
                <van-row v-if="workFlow.workflowType==3">
                  <van-col span="24">
                    <van-uploader :after-read="onReadCheng" style="width:100%">
                      <van-field label="附件" readonly placeholder="请上传附件" />
                    </van-uploader>
                  </van-col>
                </van-row>
                <!-- 成品附件的展示 -->
                 <van-row v-if="workFlow.workflowType==3">
                  <van-col span="8" v-for="pic in chengList" class="item">
                    <div style="position:relative">
                      <span class="delete" @click="deImge(pic.id,3)">×</span>
                      <img :src="pic.fileUrl" style="width:100%; height:102px;" />
                    </div>
                  </van-col>
                </van-row>

      <van-collapse v-model="tberp" v-if="!data.isTmDealOne">
        <van-collapse-item icon="edit" title="订单类型及发货信息" name="2">
          <!-- !data.isTmFstNotinAudit  非入库原料贸易专员创建出库单不应该显示同步erp -->
          <div class="pay-hd-line" v-if="!data.isTmFstNotinAudit">
            <van-cell title="是否对接ERP">
              <van-switch v-model="erp.isErp" @change="changeSynErp" />
            </van-cell>
            <van-row v-if="changeSynErps">
              <van-cell title="赠品是否同步ERP" v-if="data.isPromotionGiveOrder">
                <van-switch v-model="erp.isPromotionGiveOrder" />
              </van-cell>

              <van-cell title="使用价目表价格">
                <van-switch v-model="erp.jamubiao" @change="syjmb" />
              </van-cell>

              <van-field
                v-model="erp.entityValue"
                readonly
                label="业务实体"
                placeholder="请选择"
                @focus="entityShow"
              />

              <van-popup v-model="erp.entityPopShow" position="bottom" :overlay="true">
                <van-picker
                  :columns="erp.entityColumns"
                  show-toolbar
                  value-key="ouName"
                  @cancel="entityCancel"
                  @confirm="entityConfirm"
                  @change="entityChange"
                />
              </van-popup>

              <van-row v-if="orgIndex==2">
                <van-field
                  v-model="org.value"
                  readonly
                  label="业务库"
                  placeholder="请选择"
                  @focus="orgShow"
                />

                <van-popup v-model="org.popShow" position="bottom" :overlay="true">
                  <van-picker
                    :columns="org.columns"
                    show-toolbar
                    value-key="organizationName"
                    @cancel="orgCancel"
                    @confirm="orgConfirm"
                    @change="orgChange"
                  />
                </van-popup>
              </van-row>
            </van-row>
          </div>
          <div class="pay-hd-line" v-if="changeSynErps && !data.isTmFstNotinAudit">
            <van-field
              v-if="workFlow.workflowType!=2"
              v-model="dec.value"
              readonly
              label="发运方式"
              placeholder="请选择"
              @focus="decShow"
            />
            <van-popup v-model="dec.popShow" position="bottom" :overlay="true">
              <van-picker
                :columns="dec.columns"
                show-toolbar
                value-key="shipMethodMeaning"
                @cancel="decCancel"
                @confirm="decConfirm"
                @change="decChange"
              />
            </van-popup>

            <van-field
              v-if="workFlow.workflowType!=2"
              v-model="sec.value"
              readonly
              label="承运人"
              placeholder="请选择"
              @focus="secShow"
            />
            <van-popup v-model="sec.popShow" position="bottom" :overlay="true">
              <van-picker
                :columns="sec.columns"
                show-toolbar
                value-key="carrierName"
                @cancel="secCancel"
                @confirm="secConfirm"
                @change="secChange"
              />
            </van-popup>

            <van-field
              v-model="odt.value"
              readonly
              label="订单类型"
              placeholder="请选择"
              @focus="odtShow"
            />
            <van-popup v-model="odt.popShow" position="bottom" :overlay="true">
              <van-picker
                :columns="odt.columns"
                show-toolbar
                value-key="orderTypeName"
                @cancel="odtCancel"
                @confirm="odtConfirm"
                @change="odtChange"
              />
            </van-popup>

            <van-field v-model="jmb.value" readonly label="价目表" placeholder="请选择" @focus="jmbShow" />
            <van-popup v-model="jmb.popShow" position="bottom" :overlay="true">
              <van-picker
                :columns="jmb.columns"
                show-toolbar
                value-key="name"
                @cancel="jmbCancel"
                @confirm="jmbConfirm"
                @change="jmbChange"
              />
            </van-popup>

            <van-field
              v-model="ptm.value"
              readonly
              label="付款条件"
              placeholder="请选择"
              @focus="ptmShow"
            />
            <van-popup v-model="ptm.popShow" position="bottom" :overlay="true">
              <van-picker
                :columns="ptm.columns"
                show-toolbar
                value-key="name"
                @cancel="ptmCancel"
                @confirm="ptmConfirm"
                @change="ptmChange"
              />
            </van-popup>

            <van-field
              v-model="ywy.value"
              readonly
              label="业务员编码"
              placeholder="请选择"
              @focus="ywyShow"
            />
            <van-popup v-model="ywy.popShow" position="bottom" :overlay="true">
              <van-picker
                :columns="ywy.columns"
                show-toolbar
                @cancel="ywyCancel"
                @confirm="ywyConfirm"
                @change="ywyChange"
              />
            </van-popup>
            <van-row v-if="workFlow.workflowType!=2">
              <van-radio-group
                v-model="sourceTypeCode"
                v-if="data.isSuBmAudit  ||workFlow.workflowType==4||workFlow.workflowType==10"
              >
                <van-cell-group>
                  <van-cell title="销转采订单">
                    <van-radio name="INTERNAL" style="float: left">否</van-radio>
                    <van-radio name="EXTERNAL" style="float: left">是</van-radio>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </van-row>
          </div>

          <van-row v-if="workFlow.workflowType!=2">
            <van-radio-group v-model="chetype">
              <van-cell-group>
                <van-cell title="车次安排">
                  <van-radio name="1" style="float: left">专车</van-radio>
                  <van-radio name="2" style="float: left">拼车</van-radio>
                </van-cell>
              </van-cell-group>
            </van-radio-group>

            <van-cell-group>
              <van-field v-model="cheCode" label="车牌号" placeholder="请输入车牌号" @blur="getPhone" />

              <van-field v-model="phone" label="司机手机号" placeholder="请输入司机手机号" />
            </van-cell-group>

            <van-field
              v-model="birthday"
              label="发车时间"
              placeholder="请选择"
              @focus="showDate"
              readonly
            />
            <van-field v-model="driverName" label="司机姓名" placeholder="请输入司机姓名" />
            <van-field v-model="driverIdnumber" label="司机身份证号" placeholder="请输入司机身份证号" />

            <van-cell title="快捷录入" />
            <van-field
              type="textarea"
              v-model="speedy_input"
              @blur="getspeedy_input"
              placeholder="请输入快捷录入信息(逗号分隔)"
            />

            <van-popup v-model="popDateShow" position="bottom" :overlay="true">
              <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                @cancel="popDateShow = false"
                @confirm="onDateConfirm"
              />
            </van-popup>
          </van-row>

          <van-cell title="发货补充信息" />
          <van-field type="textarea" v-model="fhInfo" />
        </van-collapse-item>
      </van-collapse>

      <van-collapse v-model="activeNamess" class="pay-hd-item" v-if=" data.isTmDealOne">
        <van-collapse-item title="发货信息" name="13" v-if=" data.isTmDealOne">
          <div class="appr-item">
            <van-row>
              <van-row v-if="data.isTmDealOne">
                <van-row v-if="data.isTmDealOne">
                  <van-radio-group v-model="shenhefangshi" :disabled="isDisabled">
                    <van-cell-group>
                      <van-cell title="请选择审核方式">
                        <van-radio name="0" style="float: left">自审</van-radio>
                        <van-radio name="1" style="float: left">供审</van-radio>
                      </van-cell>
                    </van-cell-group>
                  </van-radio-group>

                  <van-col span="24" v-if="shenhefangshi==0">
                    <van-uploader :after-read="onRead">
                      <van-field label="发货过磅单" readonly placeholder="请上传发货过磅单" />
                    </van-uploader>
                  </van-col>
                  <van-row v-if="shenhefangshi==0">
                    <van-col span="8" v-for="pic in urlList">
                      <div>
                        <span class="delete" @click="deImge(pic.id)">×</span>
                        <img :src="pic.fileUrl" style="width:100%; height:102px;" />
                      </div>
                    </van-col>
                  </van-row>

                  <!--<van-col span="24" v-if="shenhefangshi==0">
                                        <van-button size="small" type="primary" style="margin-left: 10px"
                                                    @click="seeImge">查看图片
                                        </van-button>
                                        <van-button size="small" type="primary" style="margin-left: 10px"
                                                    @click="deImge">删除
                                        </van-button>
                                        <van-dialog
                                                v-model="imgeshow"
                                        >
                                            <img :src="imgUrl" style="width:100%; height:auto;"/>
                                        </van-dialog>
                  </van-col>-->
                </van-row>
                <!-- 供审的时候 -->
                <van-row v-if="workFlow.workflowType==10&&shenhefangshi==1">
                  <van-field
                    v-model="erp.entityValue"
                    readonly
                    label="业务实体"
                    placeholder="请选择"
                    @focus="entityShow"
                    :disabled="isDisabled"
                  />

                  <van-popup v-model="erp.entityPopShow" position="bottom" :overlay="true">
                    <van-picker
                      :columns="erp.entityColumns"
                      show-toolbar
                      value-key="ouName"
                      @cancel="entityCancel"
                      @confirm="entityConfirm"
                    />
                  </van-popup>
                </van-row>
                <van-row v-if="workFlow.workflowType==10&&shenhefangshi==1">
                  <van-field
                    v-model="org.value"
                    readonly
                    label="业务库"
                    placeholder="请选择"
                    @focus="orgShow"
                    :disabled="isDisabled"
                  />
                  <van-popup v-model="org.popShow" position="bottom" :overlay="true">
                    <van-picker
                      :columns="org.columns"
                      show-toolbar
                      value-key="organizationName"
                      @cancel="orgCancel"
                      @confirm="orgConfirm"
                    />
                  </van-popup>
                </van-row>
                <!-- 上传委托函 -->
                <van-row v-if="workFlow.workflowType==10&&shenhefangshi==1">
                  <van-col span="24">
                    <van-uploader :after-read="onReadWei" style="width:100%">
                      <van-field label="委托函" readonly placeholder="请上传附件" />
                    </van-uploader>
                  </van-col>
                </van-row>
                
                
                   <!--委托函附件的展示  -->
                <van-row v-if="workFlow.workflowType==10&&shenhefangshi==1">
                  <van-col span="8" v-for="pic in weiList" class="item">
                    <div style="position:relative">
                      <span class="delete" @click="deImge(pic.id,4)">×</span>
                      <img :src="pic.fileUrl" style="width:100%; height:102px;" />
                    </div>
                  </van-col>
                </van-row>
                <van-row >
                  <van-radio-group v-model="chetype">
                    <van-cell-group>
                      <van-cell title="车次安排">
                        <van-radio name="1" style="float: left">专车</van-radio>
                        <van-radio name="2" style="float: left">拼车</van-radio>
                      </van-cell>
                    </van-cell-group>
                  </van-radio-group>

                  <van-cell-group>
                    <van-field v-model="cheCode" label="车牌号" placeholder="请输入车牌号" @blur="getPhone" />

                    <van-field v-model="phone" label="司机手机号" placeholder="请输入司机手机号" />
                  </van-cell-group>

                  <van-field
                    v-model="birthday"
                    label="发车时间"
                    placeholder="请选择"
                    @focus="showDate"
                    readonly
                  />
                  <van-field v-model="driverName" label="司机姓名" placeholder="请输入司机姓名" />
                  <van-field v-model="driverIdnumber" label="司机身份证号" placeholder="请输入司机身份证号" />

                  <van-cell title="快捷录入" />
                  <van-field
                    type="textarea"
                    v-model="speedy_input"
                    @blur="getspeedy_input"
                    placeholder="请输入快捷录入信息(逗号分隔)"
                  />

                  <van-popup v-model="popDateShow" position="bottom" :overlay="true">
                    <van-datetime-picker
                      v-model="currentDate"
                      type="datetime"
                      @cancel="popDateShow = false"
                      @confirm="onDateConfirm"
                    />
                  </van-popup>
                </van-row>
               
                <!-- <van-row v-if="!isCreate&&workFlow.workflowType==10&&shenhefangshi==1">
                  <van-col span="12" offset="6">
                    <van-button type="info" size="large" class="danger" @click="save('1')">生成采购订单</van-button>
                  </van-col>
                </van-row>-->
              </van-row>
            </van-row>
          </div>
        </van-collapse-item>
      </van-collapse>

      <van-cell title="出库单备注" />
      <van-field type="textarea" v-model="bzremark" />
      <div class="usercenter-button" v-if="shenhefangshi!=1">
        <van-button size="large" @click="save">保 存</van-button>
      </div>
      <div class="usercenter-button" v-if="!isCreate&&workFlow.workflowType==10&&shenhefangshi==1">
        <van-button size="large" @click="save('1')">生成采购订单</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Uploader,
  Button,
  Cell,
  CellGroup,
  Col,
  Collapse,
  CollapseItem,
  DatetimePicker,
  Dialog,
  Field,
  NavBar,
  Picker,
  Popup,
  Radio,
  RadioGroup,
  Row,
  Switch,
  Tab,
  Tabs,
  Search
} from "vant";

export default {
  name: "",
  components: {
    [Uploader.name]: Uploader,
    [Dialog.name]: Dialog,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [NavBar.name]: NavBar,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Switch.name]: Switch,
     [Search.name]: Search,
  },
  data() {
    return {
      userRole: localStorage.getItem("userRole"),
      changeSynErps: true,
      activeNamess: ["13"],
      radio: "",
      tberp: ["2"],
      activeNames: ["1"],
      orderGoods: [],
      data: {},
      erp: {
        isErp: true,
        isPromotionGiveOrder: false,
        jamubiao: false,
        entityValue: "",
        entityColumns: [],
        entityPopShow: false,
        entityId: ""
      },
      org: {
        id: "",
        value: "",
        popShow: false,
        columns: []
      },
      dec: {
        id: "",
        value: "",
        code: "",
        popShow: false,
        columns: []
      },
      sec: {
        id: "",
        value: "",
        code: "",
        popShow: false,
        columns: []
      },
      odt: {
        id: "",
        value: "",
        popShow: false,
        columns: []
      },
      jmb: {
        id: "",
        value: "",
        popShow: false,
        columns: []
      },
      ptm: {
        id: "",
        value: "",
        popShow: false,
        columns: []
      },
      ywy: {
        id: "",
        value: "",
        popShow: false,
        columns: []
      },
      orgIndex: 0,
      fhInfo: "",
      sourceTypeCode: "INTERNAL",
      order: {},
      chetype: "1",
      cheCode: "",
      phone: "",
      birthday: "",
      driverName: "",
      driverIdnumber: "",
      speedy_input: "",
      popDateShow: false,
      currentDate: new Date(),
      milkdeductamount: {},
      workFlow: {},
      isNotNull: "",
      erpJson: {},
      bzremark: "",
      goodcode: [], //出库编码部分
      goodcodecolumns: [],
      goodcodeshow: false,
      goodcodeindex: 0,
      goodprice: [], //出库单价
      goodchu: [], //本次出库数量
      supplier: [], //供应商部分
      supplierid: [],
      suppliercolumns: [],
      suppliershow: false,
      supplierindex: 0,
      syncInfo: [], //同步部分
      syncInfoid: [],
      synccolumns: [{ id: 1, name: "同步进销存" }, { id: 2, name: "同步ERP" }],
      syncshow: false,
      syncindex: 0,
      shenhefangshi: "0",
      accessoryId: "",
      imgUrl: "",
      imgeshow: false,
      urlList: [],
      weiList: [],
      chengList:[],//成品附件
      list: [],
      title: [],
      goodInfo: [],
      activeName: ["-1"],
      contractList: [], //执行合同
      lists: [],
      columns: [],
      contractcolumns: [],
      contracthow: false,
      contractindex: 0,
      failCode: "",
      isDisabled: false,
      isCreate: false,
      newOrderFlag:0,//newOrderFlag==0 旧订单,切换合同变价格，1为新订单，
      Contractvalue:'',//合同的查询
    };
  },
  created (){
     this.selAuditedDetailInfo();
     this.onDateConfirm(this.currentDate);
  },
  mounted: function() {
    let that = this;
    that.lookShipmentPlan();
    that.$api.post(that.jumuc.userCenter.getPaymentTerm, null, successRes => {
      that.ptm.columns = JSON.parse(successRes.data).data;
    });
  },
  methods: {
       onSearch (){//合同的筛选
     let that=this;
      let data=that.contractcolumns[that.contractindex];
      that.columns=[];
      for(var i=0;i<data.length;i++){
         if(data[i]["name"].indexOf(this.Contractvalue)>-1){
            that.columns.push(data[i])
         }
      }
   },
    lookShipmentPlan() {
      let that = this;
      that.$api.post(
        that.jumuc.plan.lookShipmentPlan,
        { workflowId: that.$route.query.id },
        successRes => {
          if (successRes.success) {
            that.lists = successRes.data;
            for (var i = 0; i < that.lists.length; i++) {
              let k = i + 1;
              that.title[i] = "发运计划日志" + k;
              let goodJons = that.lists[i].goodsJson.split("@");
              let goodDelivery = [];
              for (var j = 0; j < goodJons.length; j++) {
                let good = goodJons[j].split(",");
                let json = {};
                if (good[0] != "") {
                  json["goodName"] = good[0];
                  json["num"] = good[1];
                  goodDelivery[j] = json;
                }
              }
              that.goodInfo[i] = goodDelivery;
            }
          }
        }
      );
    },
    changeSynErp(checked) {
      this.changeSynErps = checked;
    },
    seeImge() {
      let that = this;
      if (that.imgUrl == "") {
        that.$toast("请先上传发货过磅单");
      } else {
        that.imgeshow = true;
      }
    },
    deImge(id, type) {
      let that = this;
      that.$api.get(that.data.deleteImgUrl, { picId: id }, successRes => {
        if (successRes.result) {
          let workflowFileList = successRes.data;
          if (type == 4) {
            that.weiList = [];
            for (let i = 0; i < workflowFileList.length; i++) {
              let json = {};
              json["id"] = workflowFileList[i].picId;
              json["fileUrl"] = workflowFileList[i].url;
              that.weiList[i] = json;
            }
          }else if(type == 3){
             that.chengList = [];
            for (let i = 0; i < workflowFileList.length; i++) {
              let json = {};
              json["id"] = workflowFileList[i].picId;
              json["fileUrl"] = workflowFileList[i].url;
              that.chengList[i] = json;
            }
          }else {
            that.urlList = [];
            for (let i = 0; i < workflowFileList.length; i++) {
              let json = {};
              json["id"] = workflowFileList[i].picId;
              json["fileUrl"] = workflowFileList[i].url;
              that.urlList[i] = json;
            }
          }
          that.$toast("删除成功");
        } else {
          that.$toast("删除失败");
        }
      });
    },
    onReadWei(file) {//上传委托函
      this.uploadFile(file, 4);
    },
    onReadCheng (file){//成品上传附件
        this.uploadFile(file,3);
    },
    onRead(file, detail) {
      let that = this;
      let fileType = 1;
      if (that.data.isTmDealOne) {
        fileType = 0;
      } else if (that.data.isTmDealTwo || that.data.isBmDealTwo) {
        fileType = 1;
      }
      this.uploadFile(file, fileType);
    },
    uploadFile(file, fileType) {
      let that = this;
      let delivery = 1;
      if (that.order.isPartOut == 1) {
        delivery = 0;
      }
      let fileFormData = new FormData();
      fileFormData.append("file", file.file);
      fileFormData.append("userId", localStorage.getItem("userId"));
      fileFormData.append("fileType", fileType);
      fileFormData.append("workflowId", that.data.workFlow.id);
      fileFormData.append("delivery", delivery);

      that.$api.post(that.data.uploadUrl, fileFormData, successRes => {
        if (successRes.result) {
          let workflowFileList = successRes.data;
          if (fileType == 4) {
            that.weiList = [];
            for (let i = 0; i < workflowFileList.length; i++) {
              let json = {};
              json["id"] = workflowFileList[i].picId;
              json["fileUrl"] = workflowFileList[i].url;
              that.weiList[i] = json;
            }
          }else if(fileType == 3){//成品附件
             that.chengList = [];
            for (let i = 0; i < workflowFileList.length; i++) {
              let json = {};
              json["id"] = workflowFileList[i].picId;
              json["fileUrl"] = workflowFileList[i].url;
              that.chengList[i] = json;
              console.log(that.chengList)
            }
          }else {
            that.urlList = [];
            for (let i = 0; i < workflowFileList.length; i++) {
              let json = {};
              json["id"] = workflowFileList[i].picId;
              json["fileUrl"] = workflowFileList[i].url;
              that.urlList[i] = json;
            }
          }

          // that.urlList = [];

          // let workflowFileList = successRes.data;
          // for (let i = 0; i < workflowFileList.length; i++) {
          //       let json = {};
          //       json["id"] = workflowFileList[i].picId;
          //       json["fileUrl"] = workflowFileList[i].url;
          //   if(fileType==4){
          //       that.weiList[i] = json;
          //   }else{
          //   that.urlList[i] = json;
          //   }

          // }
          that.$toast("上传成功!");
        } else {
          that.$toast("上传失败!");
        }
      });
    },
    back() {
      history.back();
    },
    selAuditedDetailInfo() {
      let that = this;
      this.$api.post(
        that.jumuc.userCenter.selAuditedDetailInfo,
        {
          workFlowId: that.$route.query.id,
          flag: true
        },
        successRes => {
          that.orderGoods = successRes.data.orderGoods;
          that.data = successRes.data;
          that.order = successRes.data.orders;
          that.milkdeductamount = successRes.data.appUser; //奶款信息
          this.newOrderFlag=successRes.data.orders.newOrderFlag;
          try {
            if (that.data.isSuBmAudit) {
              that.ywy.value = that.milkdeductamount.businessManUserCode.split(
                ","
              )[0];
              that.ptm.value = "立即付款";
              that.ptm.id = "1001";
            }
          } catch (e) {}
          that.workFlow = successRes.data.workFlow;
          //urlList
          var workflowFileList = successRes.data.workflowFileList;
          for (let i = 0; i < workflowFileList.length; i++) {
            let json = {};
            json["id"] = workflowFileList[i].id;
            json["fileUrl"] = workflowFileList[i].fileUrl;
            if (workflowFileList[i].file_type==0||workflowFileList[i].file_type==1) {//过磅单
              that.urlList.push(json);
            }else if(workflowFileList[i].file_type==3){
                   that.chengList.push(json);
            }else{//4 委托函
              that.weiList.push(json);
            }
          }
          var len = that.orderGoods.length;
          for (let i = 0; i < len; i++) {
            if(this.workFlow.workflowType==10){//贸易的 展示合同编码
               let supplier=that.orderGoods[i].contractList[0]["supplierManage"];
                that.supplier[i] = supplier.code;
               that.supplierid[i] = supplier.id;
            }else{
               that.supplier[i] = that.orderGoods[i].listsup[0].dictdataValue;
               that.supplierid[i] = that.orderGoods[i].listsup[0].id;
            }
            that.goodcode[i] = that.orderGoods[i].goods_code.split(",")[0];
            that.goodprice[i] = that.orderGoods[i].price;
            if (that.orderGoods[i].price != 0) {
              that.goodchu[i] = 0;
            } else {
              that.goodchu[i] = that.orderGoods[i].none_delivery_goods_count;
            }
            if (that.orderGoods[i].erporjxc != null) {
              if (that.orderGoods[i].erporjxc == 1) {
                that.syncInfo[i] = "同步进销存";
                that.syncInfoid[i] = 1;
              }
              if (that.orderGoods[i].erporjxc == 2) {
                that.syncInfoid[i] = that.orderGoods[i].erporjxc;
                that.syncInfo[i] = "同步ERP";
              }
            } else {
              that.syncInfo[i] = "同步进销存";
              that.syncInfoid[i] = 1;
            }

            //执行合同
            try {
              let id = successRes.data.orderGoods[i].contract_manage_id;
              that.list[i] = id;
              let contract = successRes.data.orderGoods[i].contractList;
              let contractlist = [];
              for (var j = 0; j < contract.length; j++) {
                let json = {};
                json["id"] = contract[j].id;
                json["name"] = contract[j].contractName;
                json["price"] = contract[j].price;
                json["daysPrice"] = contract[j].daysPrice;
                json["supplierManage"]=contract[j].supplierManage;
                contractlist[j] = json;
                if(id){
                     if (id == contract[j].id) {
                      id = contract[j].contractName;
                    }
                }else{
                   id = contract[0].contractName;
                } 
                
              }
              that.contractList[i] = id;
              that.contractcolumns[i] = contractlist;
              if (i == 0) {
                that.columns = that.contractcolumns[0];
              }
            } catch (e) {}
          }
          that.radio = successRes.data.appUser.milkShopList[0].orgCode;
        }
      );
    },
    save(type) {
      //保存 和生成采购订单type为1
      let that = this;
      that.erpJson["status"] = "1";
      that.erpJson["workflowId"] = that.data.workFlow.id;
      that.erpJson["orderId"] = that.order.id;
      if (that.data.isPromotionGiveOrder) {
        that.erpJson["synGiftErp"] =
          that.erp.isPromotionGiveOrder == true ? 1 : 0;
      }
      if (!that.data.isTmDealOne) {
        that.erpJson["isMilkShopGoods"] = "1";
        // !data.isTmFstNotinAudit  非入库原料贸易专员创建出库单不应该显示同步erp
        if (!that.data.isTmFstNotinAudit) {
          that.erpJson["syncErp"] = that.erp.isErp == true ? 1 : 0;
        }
      }

      that.erpJson["shipInfo"] = that.fhInfo;
      that.erpJson["departureTime"] = that.birthday;
      that.erpJson["plateNo"] = that.cheCode;
      that.erpJson["driverName"] = that.driverName;
      that.erpJson["driverIdnumber"] = that.driverIdnumber;
      that.erpJson["mobileDriver"] = that.phone;
      that.erpJson["transport"] = that.order.transport;
      that.erpJson["trainType"] = that.chetype;
      that.erpJson["remark"] = that.bzremark;
      if (that.data.isTmDealOne) {
        that.erpJson["approvalType"] = that.shenhefangshi;
      }
      let isDelivery = true;
      let detailData = [];
      let goodscheckStork = "";
      for (var i = 0; i < that.orderGoods.length; i++) {
        let json = {};
        json["goods_id"] = that.orderGoods[i].goodsId;
         json["skuCode"] = that.orderGoods[i].sku_code;
        json["delivery_price"] = that.goodprice[i];

        if (that.goodchu[i] == "") {
          that.goodchu[i] = 0;
        }
        json["delivery_count"] = that.goodchu[i];
        if (that.goodchu[i] > 0) {
          isDelivery = false;
        }

       

        if (that.workFlow.workflowType == 2) {
          json["istongbu"] = that.syncInfoid[i];
        }
        json["goods_out_code"] = that.goodcode[i];
        json["erp_price"] = that.orderGoods[i].jmbjg;
        json["isGift"] =
          that.orderGoods[i].parent_cart_id == null ? false : true;
        json["contract"] = that.list[i];
        console.log(that.supplierid[i])
        debugger
         json["suppler_id"] = that.supplierid[i];
        if (that.workFlow.workflowType == 2 && that.syncInfoid[i] == 1) {
          goodscheckStork =
            goodscheckStork +
            that.goodcode[i] +
            "," +
            that.goodchu[i] +
            "," +
            that.orderGoods[i].unit_zhxs +
            ";";
        }
        detailData.push(json);
      }
      if (that.data.workFlow.workflowType == 2) {
        that.erpJson["orgMilkShop"] = that.radio;
        that.erpJson["goodscheckStork"] = goodscheckStork;
      }
      if (isDelivery) {
        that.$toast("出库单至少有一种商品出库数量不为0");
        return false;
      }
      that.erpJson["detailData"] = JSON.stringify(detailData);
      //!data.isTmFstNotinAudit  非入库原料贸易专员创建出库单不应该显示同步erp
      if (
        that.erp.isErp &&
        !that.data.isTmDealOne &&
        !that.data.isTmFstNotinAudit
      ) {
        //同步erp
        that.getIsNotNull();
        if (that.isNotNull != "") {
          that.$toast(that.isNotNull);
          return false;
        }
      }
      //供审的时候 传的参数
      if (this.workFlow.workflowType == "10" && this.shenhefangshi == "1") {
        this.erpJson["purCuxOu"] = this.erp.entityId;
        this.erpJson["purCuxOuName"] = this.erp.entityValue;
        this.erpJson["purWarehouseId"] = this.org.id;
        this.erpJson["purWarehouseName"] = this.org.value;
      }
      /*if (that.workFlow.workflowType != 2 && that.order.transport != '自提') {
                    if (that.cheCode == '') {
                        that.$toast('车牌号不能为空')
                        return false
                    }
                    if (that.phone == '') {
                        that.$toast('司机手机号不能为空')
                        return false
                    }
                    if (that.birthday == '') {
                        that.$toast('发车时间不能为空')
                        return false
                    }

                    if (that.driverName == null || that.driverName == '') {
                        that.$toast('请输入司机姓名')
                        return false
                    }

                    if (that.driverIdnumber == null || that.driverIdnumber == '') {
                        that.$toast('请输入司机身份证号')
                        return false
                    }
                }*/
      if (type == "1") {
        //供审的时候，生成采购订单
        this.createOrder(this.erpJson);
      } else {
        that.$api.post(
          that.jumuc.userCenter.deliveryGoodsorderCreateSave,
          that.erpJson,
          successRes => {
            if (successRes.success) {
              Dialog.alert({
                title: "",
                message: successRes.msg
              }).then(() => {
                if (localStorage.getItem("userRole").indexOf("WM") > 0) {
                  this.$router.push({
                    path: "/staff/delivery/list"
                  });
                } else if (localStorage.getItem("userRole") == "SUM") {
                  this.$router.push({
                    path: "/staff/delivery/detail",
                    query: {
                      type: 0,
                      isEdit: true,
                      orderId: that.order.id,
                      outId: successRes.data,
                      workflowId: that.workFlow.id,
                      status: "2"
                    }
                  });
                } else {
                  history.back();
                }
              });
            } else {
              Dialog.alert({
                title: "",
                message: successRes.msg
              });
            }
          }
        );
      }
    },
    createOrder(data) {
      //生成采购单
      //if (this.workFlow.workflowType == "10" && this.shenhefangshi == "1") {
      if (data.purCuxOu == "") {
        this.$toast("业务实体不能为空");
        return false;
      } else if (data.purWarehouseId == "") {
        this.$toast("业务库不能为空");
        return false;
      } else {
        this.$api.post(this.jumuc.createChuOrder, data, successRes => {
          this.$toast(successRes.msg);
          if (successRes.success) {
            this.isDisabled = true;
            this.shenhefangshi = "1";
            this.isCreate = true;
          }
        });
      }
      //}
    },
    entityShow() {
      //选择业务实体部分
      let that = this;
      that.getOuByCus(); //erp信息-获取业务实体
      that.entIndex = 1;
      that.erp.entityPopShow = true;
    },
    entityCancel() {
      let that = this;
      that.erp.entityPopShow = false;
    },
    entityConfirm(values) {
      let that = this;
      that.erp.entityValue = values.ouName;
      that.erp.entityId = values.orgId;
      that.erp.entityPopShow = false;
      that.entIndex = 2;
      that.orgIndex = 2;
    },
    entityChange(picker, values) {
      let that = this;
      that.org.value = "";
      that.dec.value = "";
      that.sec.value = "";
      that.odt.value = "";
      that.jmb.value = "";
      that.ptm.value = "";
      that.erp.jamubiao = false;
      picker.setColumnValues(1, values[0].ouName);
    },
    orgShow() {
      //选择业务库部分
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getOrgByOuId,
        { ouId: that.erp.entityId },
        successRes => {
          that.org.columns = JSON.parse(successRes.data).data;
        }
      );
      that.org.popShow = true;
    },
    orgCancel() {
      let that = this;
      that.org.popShow = false;
    },
    orgConfirm(values) {
      let that = this;
      that.org.value = values.organizationName;
      that.org.id = values.organizationId;
      that.org.popShow = false;
      that.entIndex = 3;
    },
    orgChange(picker, values) {
      let that = this;
      that.dec.value = "";
      that.sec.value = "";
      picker.setColumnValues(1, values.organizationName);
    },
    decShow() {
      //选择发运方式部分
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getShimpmenthodEc,
        { organizationId: that.org.id },
        successRes => {
          that.dec.columns = JSON.parse(successRes.data).data;
        }
      );
      that.dec.popShow = true;
    },
    decCancel() {
      let that = this;
      that.dec.popShow = false;
    },
    decConfirm(values) {
      let that = this;
      that.dec.value = values.shipMethodMeaning;
      that.dec.id = values.carrierId;
      that.dec.code = values.shipMethodCode;
      that.dec.popShow = false;
      that.entIndex = 4;
    },
    decChange(picker, values) {
      let that = this;
      that.sec.columns = [];
      that.sec.value = "";
      picker.setColumnValues(1, values.shipMethodMeaning);
    },
    secShow() {
      //选择承运人部分
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getCarriersEc,
        { organizationId: that.org.id, carrierId: that.dec.id },
        successRes => {
          that.sec.columns = JSON.parse(successRes.data).data;
        }
      );
      that.sec.popShow = true;
    },
    secCancel() {
      let that = this;
      that.sec.popShow = false;
    },
    secConfirm(values) {
      let that = this;
      that.sec.value = values.carrierName;
      that.sec.id = values.carrierId;
      that.sec.code = values.freightCode;
      that.sec.popShow = false;
      that.entIndex = 5;
    },
    secChange(picker, values) {
      picker.setColumnValues(1, values.carrierName);
    },
    odtShow() {
      //选择订单类型部分
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getOrderTypeListByOuId,
        { ouId: that.erp.entityId, typeCode: "ORDER" },
        successRes => {
          that.odt.columns = JSON.parse(successRes.data).data;
        }
      );
      that.odt.popShow = true;
    },
    odtCancel() {
      let that = this;
      that.odt.popShow = false;
    },
    odtConfirm(values) {
      let that = this;
      that.odt.value = values.orderTypeName;
      that.odt.id = values.orderTypeId;
      that.odt.popShow = false;
      that.entIndex = 6;
    },
    odtChange(picker, values) {
      picker.setColumnValues(1, values.orderTypeName);
    },
    jmbShow() {
      //价目表部分
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getPriceListByOuIdAndOrderId,
        { ouId: that.erp.entityId, workFlowId: that.workFlow.id },
        successRes => {
          that.jmb.columns = JSON.parse(successRes.data).data;
        }
      );
      that.jmb.popShow = true;
    },
    jmbCancel() {
      let that = this;
      that.jmb.popShow = false;
    },
    jmbConfirm(values) {
      let that = this;
      that.jmb.value = values.name;
      that.jmb.id = values.listHeaderId;
      that.jmb.popShow = false;
      that.entIndex = 7;
      that.getGoodsPriceByPriceListIdAndGoodsId();
    },
    jmbChange(picker, values) {
      picker.setColumnValues(1, values.name);
    },
    ptmShow() {
      //选择付款条件部分
      let that = this;
      that.$api.post(that.jumuc.userCenter.getPaymentTerm, null, successRes => {
        that.ptm.columns = JSON.parse(successRes.data).data;
      });
      that.ptm.popShow = true;
    },
    ptmCancel() {
      let that = this;
      that.ptm.popShow = false;
    },
    ptmConfirm(values) {
      let that = this;
      that.ptm.value = values.name;
      that.ptm.id = values.paymentTermId;
      that.ptm.popShow = false;
      that.entIndex = 8;
    },
    ptmChange(picker, values) {
      picker.setColumnValues(1, values.name);
    },
    ywyShow() {
      //选择业务编码部分
      let that = this;
      that.ywy.columns = that.milkdeductamount.businessManUserCode.split(",");
      that.ywy.popShow = true;
    },
    ywyCancel() {
      let that = this;
      that.ywy.popShow = false;
    },
    ywyConfirm(values) {
      let that = this;
      that.ywy.value = values;
      that.ywy.popShow = false;
      that.entIndex = 9;
    },
    ywyChange(picker, values) {
      picker.setColumnValues(1, values);
    },
    getPhone() {
      //根据车牌号获取手机号
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getDriver,
        { carNumber: that.cheCode },
        successRes => {
          that.phone = successRes.data.driver_mobile;
          that.cheCode = successRes.data.driver_car_number;
          that.driverName = successRes.data.driver_name;
          that.driverIdnumber = successRes.data.driver_idnumber;
        }
      );
    },
    getOuByCus() {
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getOuByCus,
        { id: that.milkdeductamount.id },
        successRes => {
          that.erp.entityColumns = JSON.parse(successRes.data).data;
        }
      );
    },
    syjmb(checked) {
      //是否使用价目价格
      let that = this;
      if (checked && that.jmb.value == "") {
        that.$toast("请选择价目表");
        that.erp.jamubiao = false;
      }
      if (that.failCode != "") {
        Dialog.alert({
          title: "",
          message:
            "出库编码" +
            that.failCode +
            "的商品没有在该价目表中，如需使用价目表价格请将商品维护到该价目表中"
        }).then(() => {
          that.erp.jamubiao = false;
        });
      }
    },
    showDate() {
      this.popDateShow = true;
    },
    onDateConfirm(value) {
      const d = new Date(value);
      const resDate =
        d.getFullYear() +
        "-" +
        this.p(d.getMonth() + 1) +
        "-" +
        this.p(d.getDate());
      const resTime =
        this.p(d.getHours()) +
        ":" +
        this.p(d.getMinutes()) +
        ":" +
        this.p(d.getSeconds());
      this.birthday = resDate + " " + resTime;
      this.popDateShow = false;
    },
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    goodcodeShow(item, index) {
      //选择业务编码部分
      let that = this;
      that.goodcodeindex = index;
      that.goodcodecolumns = item.goods_code.split(",");
      that.goodcodeshow = true;
    },
    goodcodeCancel() {
      let that = this;
      that.goodcodeshow = false;
    },
    goodcodeConfirm(values) {
      let that = this;
      that.goodcode[that.goodcodeindex] = values;
      that.goodcodeshow = false;
    },
    goodcodeChange(picker, values) {
      picker.setColumnValues(1, values);
    },
    supplierShow(item, index) {
      //选择业务编码部分
      let that = this;
      that.supplierid[that.supplierindex] = [];
      that.supplierindex = index;
      for (var i = 0; i < item.listsup.length; i++) {
        let json = {};
        json["id"] = item.listsup[i].id;
        json["name"] = item.listsup[i].dictdataValue;
        that.suppliercolumns[i] = json;
      }
      that.suppliershow = true;
    },
    supplierCancel() {
      let that = this;
      that.suppliershow = false;
    },
    supplierConfirm(values) {
      let that = this;
      that.supplier[that.supplierindex] = values.name;
      that.supplierid[that.supplierindex] = values.id;
      that.suppliershow = false;
    },
    supplierChange(picker, values) {
      picker.setColumnValues(1, values);
    },
    syncShow(index) {
      //选择业务编码部分
      let that = this;
      that.syncindex = index;
      that.syncshow = true;
    },
    syncCancel() {
      let that = this;
      that.syncshow = false;
    },
    syncConfirm(values) {
      let that = this;
      that.syncInfo[that.syncindex] = values.name;
      that.syncInfoid[that.syncindex] = values.id;
      that.syncshow = false;
    },
    syncChange(picker, values) {
      picker.setColumnValues(1, values);
    },
    getGoodsPriceByPriceListIdAndGoodsId() {
      let that = this;
      let goodsId = [];
      let json = {};
      let goodsCode = "";
      let code = [];
      for (var i = 0; i < that.orderGoods.length; i++) {
        json["goodsId"] = that.goodcode[i];
        json["unit_zhxs"] = that.orderGoods[i].unit_zhxs;
        goodsId[i] = json;
        goodsCode = goodsCode + that.goodcode[i] + ",";
        code[i] = that.goodcode[i];
      }
      //erp信息-获取价目表价格
      that.$api.post(
        that.jumuc.userCenter.getGoodsPriceByPriceListIdAndGoodsId,
        {
          priceId: that.jmb.id,
          goodsId: JSON.stringify(goodsId),
          goodsCode: goodsCode
        },
        successRes => {
          let data = JSON.parse(successRes.data).data;
          that.orderGoods = [];
          that.jmdata = data;
          for (var k = 0; k < that.data.orderGoods.length; k++) {
            let good = that.data.orderGoods[k];
            that.orderGoods[k] = good;
            for (var key in data) {
              if (that.goodcode[k] == key) {
                good["jmbjg"] = data[key];
                that.orderGoods[k] = good;
              }
            }
          }
          //判断返回数据是否完整
          var codes = "";
          for (var j = 0; j < code.length; j++) {
            if (data[code[j]] == null) {
              codes += code[j] + " ";
            }
          }
          that.failCode = codes;
        }
      );
    },
    getIsNotNull() {
      //同步erp 审核通过接口参数封装
      let that = this;
      that.isNotNull = "";
      //本次订单扣减奶款
      that.erpJson["finalDeductAmount"] = that.order.shouldPayPrice;

      if (that.erp.entityId == "") {
        //业务实体id
        that.isNotNull = "业务实体id不能为空";
        return false;
      }
      that.erpJson["cuxOu"] = that.erp.entityId;

      if (that.erp.entityValue == "") {
        //业务实体名称
        that.isNotNull = "业务实体名称不能为空";
        return false;
      }
      that.erpJson["cuxOuName"] = that.erp.entityValue;

      if (that.org.id == "") {
        //库id
        that.isNotNull = "业务库不能为空";
        return false;
      }
      that.erpJson["warehouseId"] = that.org.id;

      if (that.org.value == "") {
        //库名称
        that.isNotNull = "业务库名称不能为空";
        return false;
      }
      that.erpJson["warehouseName"] = that.org.value;

      /*  if (that.dec.code == '') { //发运方式
                      that.isNotNull = '发运方式不能为空';
                      return false
                  }*/
      that.erpJson["shippingMethodCode"] = that.dec.code;

      /*if (that.sec.code == '') { //承运人
                    that.isNotNull = '承运人不能为空';
                    return false
                }*/
      that.erpJson["freightCarrierCode"] = that.sec.code;

      if (that.odt.value == "") {
        //订单类型名称
        that.isNotNull = "订单类型名称不能为空";
        return false;
      }
      that.erpJson["businessTypeName"] = that.odt.value;

      if (that.odt.id == "") {
        //订单类型id
        that.isNotNull = "订单类型id不能为空";
        return false;
      }
      that.erpJson["businessType"] = that.odt.id;

      if (that.jmb.value == "") {
        //价目表名称
        that.isNotNull = "价目表名称不能为空";
        return false;
      }
      that.erpJson["priceListName"] = that.jmb.value;

      if (that.jmb.id == "") {
        //价目表id
        that.isNotNull = "价目表id不能为空";
        return false;
      }
      that.erpJson["priceListId"] = that.jmb.id;

      if (that.ptm.value == "") {
        //付款条件名称
        that.isNotNull = "付款条件名称不能为空";
        return false;
      }
      that.erpJson["paymentTermName"] = that.ptm.value;

      if (that.ptm.id == "") {
        //付款条件id
        that.isNotNull = "付款条件id不能为空";
        return false;
      }
      that.erpJson["paymentTerm"] = that.ptm.id;

      if (that.ywy.value == "") {
        //业务员编码
        that.isNotNull = "业务员编码不能为空";
        return false;
      }
      that.erpJson["bmUserCode"] = that.ywy.value;

      /* if (that.fhInfo == '') { //发货信息补充
                     that.isNotNull = '发货信息补充不能为空';
                     return false
                 }*/
      that.erpJson["shipInfo"] = that.fhInfo;

      let str = "";
      for (var i = 0; i < that.goodcode.length; i++) {
        if (i == that.goodcode.length) {
          str = str + that.goodcode[i] + "-" + that.supplierid[i];
        } else {
          str = str + that.goodcode[i] + "-" + that.supplierid[i] + ",";
        }
      }
      if (str == "") {
        //供应商id
        that.isNotNull = "供应商id不能为空";
        return false;
      }
      that.erpJson["supplerCode"] = str;

      let gz = that.syncInfoid;
      let syncJxcCode = "";
      let syncErpCode = "";
      for (var i = 0; i < gz.length; i++) {
        if (gz[i] == 1) {
          //同步进销存
          syncJxcCode = syncJxcCode + that.goodcode[i] + ",";
        }
        if (gz[i] == 2) {
          //同步ERP
          syncErpCode = syncErpCode + that.goodcode[i] + ",";
        }
      }
      if (syncJxcCode != "") {
        syncJxcCode = syncJxcCode.substring(0, syncJxcCode.length - 1);
      }
      if (syncErpCode != "") {
        syncErpCode = syncErpCode.substring(0, syncErpCode.length - 1);
      }
      that.erpJson["syncJxcCode"] = syncJxcCode; //同步进销存
      that.erpJson["syncErpCode"] = syncErpCode; //同步ERP

      that.erpJson["sourceTypeCode"] = that.sourceTypeCode; //销转采订单
    },
    contractShow(item, index) {
      //选择执行合同
      let that = this;
      that.contractindex = index;
      that.columns = that.contractcolumns[index];
      that.contracthow = true;
      this.Contractvalue="";
    },
    gcontractCancel() {
      let that = this;
      that.contracthow = false;
    },
    contractConfirm(values) {
      let that = this;
       that.contractList[that.contractindex] = values.name;
      that.list[that.contractindex] = values.id;
      if(this.newOrderFlag==0){//旧订单，变价格
          //重新设置单价
          let obj = that.orderGoods[that.contractindex];
          if (obj.payment == 1) {
            //现金
            that.goodprice[that.contractindex] = values.price;
          } else if (obj.payment == 2) {
            //账期
            that.goodprice[that.contractindex] = values.daysPrice;
          }
      }
      if(this.workFlow.workflowType==10){
         that.supplier[that.contractindex]=values["supplierManage"]["code"];
          that.supplierid[that.contractindex] = values["supplierManage"].id;
      }
        that.contracthow = false;
    },
    contractChange(picker, values) {
      picker.setColumnValues(1, values);
    },
    getspeedy_input() {
      let that = this;
      that.speedy_input = that.speedy_input.replace(/，|,/g, ",");
      let arry = [];
      arry = that.speedy_input.split(",");
      that.cheCode = arry[2];
      that.birthday = arry[4];
      that.phone = arry[1];
      that.driverName = arry[0];
      that.driverIdnumber = arry[3];
    }
  }
};
</script>
<style lang="less">
body {
  background: #f7f7ff;
}

@bule-thame: #3c6eeb;
.jump-useraddress {
  button.van-button {
    background-color: @bule-thame;
    color: white;
    font-weight: 700;
    border-radius: 5px;
    margin: 25px 0 10px;
  }
}

@bule-thame: #3c6eeb;

body {
  background-color: #f7f7f7;
}

.jump-cart {
  .usercenter-button {
    padding: 0 15px;
    button {
      background-color: @bule-thame;
      color: white;
      font-weight: 700;
      border-radius: 5px;
      margin: 25px 0 10px;
    }
  }

  .van-hairline--bottom::after {
    border-bottom-width: 0px;
  }
  &-body {
    padding: 20px 10px 0;
    position: relative;
    &-hd {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      background-color: @bule-thame;
    }
  }
  &-item {
    background-color: #fff;
    margin-bottom: 15px;
    align-items: center;
    border-radius: 20px;
    padding: 15px;
    position: relative;
    .van-checkbox {
      height: 100%;
      line-height: 100%;
    }
    &-img {
      img {
        width: 100%;
      }
    }

    h4 {
      font-size: 14px;
      padding: 10px 0;
    }
    &-warp {
      align-self: flex-start;
    }
    p {
      font-size: 14px;
      &.item-time {
        color: @bule-thame;
        font-size: 16px;
        text-align: right;
      }
      &.item-price {
        color: red;
        font-size: 16px;
        i {
          font-size: 18px;
          float: right;
          color: #f5a623;
        }
      }
    }
  }
}

.delete {
  font-size: 28px;
  position: absolute;
 top:-15px;
 right:0;
}
</style>

